<div class="widgetListContainer">
  <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  <sn-empty-state
    fontSet="fal"
    fontIcon="fa-objects-column"
    [title]="'navigation.operationalDashboards' | t"
    *ngIf="!selectedView"
  >
    {{ 'dashboard.operational.widgets.selectDashboard' | t }}
  </sn-empty-state>
  <div class="fs-row" *ngIf="selectedView">
    <ng-container *ngIf="selectedView.widgets?.length && !isLoading">
      <ng-container *ngFor="let widget of selectedView?.widgets">
        <div class="widgetContainer fs-col" *ngIf="!widget.popout">
          <button mat-fab class="popoutBtn" [matTooltip]="'dashboard.operational.widgets.undockWidget' | t" (click)="onPopout(widget)">
            <sn-icon fontIcon="fa-arrow-up-right-from-square" fontSet="far"></sn-icon>
          </button>
          <ng-container [ngSwitch]="widget.widget">
            <fs-alarms-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'alert'"
            ></fs-alarms-widget>
            <sn-camera-live-view-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'camera_live_view'"
            ></sn-camera-live-view-widget>
            <sn-camera-grids-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'camera_grids'"
            ></sn-camera-grids-widget>
            <sn-analytics-widget
              #analytics
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'heatmap_analytics'"
            ></sn-analytics-widget>
            <sn-chat-channel-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              (widgetUpdated)="onWidgetUpdated($event)"
              *ngSwitchCase="'chat_channel'"
            ></sn-chat-channel-widget>
            <sn-embed-youtube-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'embed_youtube'"
            ></sn-embed-youtube-widget>
            <sn-embed-code-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'embed_code'"
            ></sn-embed-code-widget>
            <sn-facebook-live-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'facebook_live'"
            ></sn-facebook-live-widget>
            <sn-content-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              (widgetUpdated)="onWidgetUpdated($event)"
              *ngSwitchCase="'content'"
            ></sn-content-widget>
            <sn-twitter-embed-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'twitter_timeline_embed'"
            ></sn-twitter-embed-widget>
            <sn-website-iframe-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'website_iframe'"
            ></sn-website-iframe-widget>
            <sn-media-widget
              [widget]="widget"
              [viewId]="widget.operationalView"
              *ngSwitchCase="'media_widget'"
            ></sn-media-widget>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <sn-empty-state
      icon="cancel_presentation"
      [title]="'common.noWidgetsFound' | t"
      *ngIf="!selectedView.widgets?.length && !isLoading"
    >
    </sn-empty-state>
    <mat-spinner
      color="accent"
      diameter="48"
      *ngIf="!selectedView.widgets?.length && isLoading"
    ></mat-spinner>
  </div>
</div>
